/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Member_Detail_Standing_ActiveInputs */



/**
* | output |
* | --- |
* | "This member can sign in and use oneAI." |
*
* @param {Member_Detail_Standing_ActiveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const member_detail_standing_active = /** @type {((inputs?: Member_Detail_Standing_ActiveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Detail_Standing_ActiveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Mitglied kann sich anmelden und oneAI nutzen.")
	return /** @type {LocalizedString} */ ("This member can sign in and use oneAI.")
});